// Combinações sugeridas entre tecidos, para quem gosta de personalizar mas não sabe combinar.
// Lista editável: [tecido, tecido que lhe assenta bem]. Só aparecem se ambos existirem no catálogo.
export const COMBOS = [
  ["vichy-bege", "bordado-branco"],
  ["flores-rosa", "waffle-rosa-bebe"],
  ["riscas-finas-azuis", "waffle-branco"],
  ["vichy-cereja", "waffle-bege"],
  ["folhas-azuis", "vichy-azul"],
];

export const combosFor = (id) => COMBOS.filter(([a, b]) => a === id || b === id).map(([a, b]) => (a === id ? b : a));
